module.exports = __webpack_public_path__ + "templates.sl_loading_spinner-b4421511.html";